
<div class="bingo-entete">
  <div id="entete" class="container-xs">
    <div id="nav" class="row">
      <div class="d-lg-flex justify-content-end w-100 d-none pt-1">
        <ul class="d-flex m-0 p-0">
          <li class="mr-3 d-flex align-items-center">
            <div class="rounded-circle bingo_cercle mr-1"></div>
            <a :href="$t('messageComponent.promotionsURL')">{{
              $t('messageComponent.promotions')
            }}</a>
          </li>
          <li class="mr-3 d-flex align-items-center">
            <div class="rounded-circle bingo_cercle mr-1"></div>
            <a :href="$t('messageComponent.gagnantsURL')">{{
              $t('messageComponent.gagnants')
            }}</a>
          </li>
          <li class="d-flex align-items-center">
            <div class="rounded-circle bingo_cercle mr-1"></div>
            <a :href="$t('messageComponent.jeuResponsableURL')">{{
              $t('messageComponent.jeuResponsable')
            }}</a>
          </li>
        </ul>
      </div>

      <br />

      <b-navbar toggleable="lg" class="navbar_overlay w-100 px-0">
        <b-link class="ml-3" :to="{ path: $t('messageComponent.accueilURL') }">
          <img
            :src="`${mixinEnvironnement_damPath}/jel/bingo/logo/bingo.svg`"
            class="d-inline-block align-top nav_bingo_icon"
            alt="Logo - Bingo"
          />
        </b-link>
        <b-navbar-toggle
          target="nav-collapse"
          class="float-right text-right toggler_icon"
          :class="{ 'd-none': afficherMenu }"
        >
        </b-navbar-toggle>
        <div
          id="navbar-close"
          :class="!afficherMenu ? 'd-none' : 'pr-1'"
          @click="afficherMenu = !afficherMenu"
        >
          <img
            :src="`${mixinEnvironnement_damPath}/jel/bingo/icones/icon_closeLobby.svg`"
            class="close_menu_icon"
            alt="close-menu"
          />
        </div>

        <b-collapse id="nav-collapse" v-model="afficherMenu" class="navbar_content" is-nav>
          <b-navbar-nav class="w-100 navbar_content_titles">
            <div
              v-for="(routes, index) in actualRoutes"
              :key="index"
              class="btn-group route_btn graphik_semibold px-1"
            >
              <!-- Contenu à remettre si le menu ont des dropdowns sur les éléments principaux
            <b-nav-item-dropdown
              v-if="routes.length > 1"
              :ref="'drop-' + routes[0].parent"
              :text="routes[0].parent"
              size="sm"
              variant="primary"
              class="w-100 d-lg-flex align-items-center justify-content-lg-center"
              :toggle-class="[getParentActive(routes), 'entete_btn']"
              @mouseover.native="() => showDropdown('drop-' + routes[0].parent, $mq, true)"
              @mouseleave.native="() => showDropdown('drop-' + routes[0].parent, $mq, false)"
            >
              <b-dropdown-item
                v-for="route in routes"
                :key="route.name"
                :to="route.path"
                class="dropdown-item"
              >
                {{ route.menuTitle }}
              </b-dropdown-item>
            </b-nav-item-dropdown>
          -->

              <b-nav-item class="d-flex align-items-center justify-content-lg-center">
                <router-link :to="routes['@path']">
                  {{ routes.menuTitle }}
                </router-link>
              </b-nav-item>
            </div>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
  </div>
</div>
